import React, { Children, cloneElement, forwardRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Root } from './TableRow.styles'

/**
 * The TableRow's component.
 */
const TableRow = forwardRef((props, ref) => {
  const { children, enableHead, selected, ...restProps } = props
  const cells = useMemo(
    () => Children.map(children, child => (enableHead ? cloneElement(child, { enableHead }) : child)),
    [children, enableHead]
  )

  return (
    <Root {...restProps} data-selected={selected ? 'true' : 'false'} ref={ref}>
      {cells}
    </Root>
  )
})

TableRow.defaultProps = {
  enableHead: false,
  selected: false
}

TableRow.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Enable head.
   */
  enableHead: PropTypes.bool,
  /**
   * Margin.
   */
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding.
   */
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Selected.
   */
  selected: PropTypes.bool
}

export default TableRow
